export interface WorkPreparationReasonId {__workPreparationReasonId: number;}

export default class WorkPreparationReason {
  id!: WorkPreparationReasonId;
  description = '';
}